module.exports = __webpack_public_path__ + "ceb47f25afd5122d144325d531e1ef96.ttf";